<template>
  <div id="rePayPassword">
    <mt-header fixed :title="$t('设置支付密码')">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
    </mt-header>
    <div class="container">
      <div class="swiper">
        <p class="wx_fontSize3">
          {{ first ? $t("请输入密码") : $t("请再次输入") }}
        </p>
      </div>
      <div class="passContainer">
        <Password v-on:end="onEnd" ref="pass"></Password>
      </div>
    </div>
    <VerifyPopup
      ref="refVerify"
      scene="credentials_add_pay_pwd"
      @onVerify="onSubmit"
    />
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import VerifyPopup from "@/components/VerifyPopup";
import Password from "@/components/Password";
import { httpSetPayPassword } from "@/api/userCenter";
export default {
  components: { Toast, Password, VerifyPopup },
  data() {
    return {
      first: true,
      firstValue: "",
    };
  },
  methods: {
    onEnd: function (val) {
      if (this.first) {
        this.first = false;
        this.firstValue = val;
        this.$refs.pass.reset();
        return;
      } else {
        if (this.firstValue != val) {
          Toast(this.$t("noequal"));
          this.first = true;
          this.firstValue = "";
          this.$refs.pass.reset();
          return;
        } else {
          this.pwd = val;
          if (this.credentials) {
            this.onSubmit(this.credentials);
          } else {
            this.$refs.refVerify.show = true;
          }
        }
      }
    },
    onSubmit(credentials) {
      this.credentials = credentials;
      const payload = {
        pwd: this.pwd,
      };
      if (parseInt(Date.now() / 1000) > credentials.expiretime) {
        this.$refs.refVerify.show = true;
        return false;
      } else {
        payload.credentials = credentials.credentials;
      }

      // 新增支付密码接口
      httpSetPayPassword(payload)
        .then((res) => {
          Toast(res.msg);
          this.$router.back();
        })
        .catch(() => {});
    },
  },
  mounted() {},
};
</script>

<style scoped>
#rePayPassword {
  width: 100%;
}
.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.container {
  padding: 50px 10px 10px 10px;
}
.swiper {
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 10px;
  color: #4a4a4a;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 20px;
}
.swiper p {
  margin: 5px;
}
</style>
